export const appSettings = {
  siteLogo: "/Images/FlermoLogoWhite.svg",
  primaryColor: "#2e2e2e", 
  secondaryColor: "#fff",
  defaultLanguage: "en",

  api: {
    contactEndpoint: "/api/contact",
  },

  features: {
    enableAuth: true,
    enableFooterContactForm: true,
    heroBackgroundImage: "/Images/layered-waves-haikei.png",  // Put your image in public/assets
  },
};